/* eslint-disable no-useless-escape */
import app from 'app';
import 'spectrum';
import ExternalScripts from '#/externalScripts';

/**
 * @param fn {function}
 * @param delay {number}
 * @constructor
 */
app.namespace.Util.Timer = function (fn, delay) {
  if (!(typeof fn === 'function' && 0 < delay)) {
    throw new Error('Timer Function Arguments Defence Alert');
  }

  this.isActive = false;
  this._startedTime = 0;
  this._pausedTime = 0;
  this._delay = delay;
  this._timer = null;
  this._fn = () => {
    try {
      this._args ? fn(...this._args) : fn();
    } catch (bug) {
      app.doctorController.report('app.namespace.Util.Timer', bug);
    }
    this.isActive = false;
    this._pausedTime = 0;
    this._startedTime = 0;
  };
};

$.extend(app.namespace.Util.Timer.prototype, {
  /**
   * @param delay
   * @return {app.namespace.Util.Timer}
   */
  setDelay(delay) {
    this._delay = Math.max(8, delay);
    return this;
  },

  /**
   * @return {$.Deferred}
   */
  trigger(...args) {
    this._args = args;
    this._fn();
    return this;
  },

  /**
   * @return {app.namespace.Util.Timer}
   */
  stop() {
    if (this.isActive) {
      // noinspection JSVoidFunctionReturnValueUsed
      this._timer = window.clearTimeout(this._timer);
      this.isActive = false;
      this._pausedTime = 0;
      this._startedTime = 0;
    }
    return this;
  },

  /**
   * @return {$.Deferred}
   */
  start(...args) {
    this.stop();

    this.isActive = true;
    this._args = args;
    this._timer = window.setTimeout(this._fn, this._delay);
    this._pausedTime = 0;
    this._startedTime = Date.now();

    return this;
  },

  restart() {
    return this.stop().start();
  },

  pause() {
    if (this.isActive) {
      // noinspection JSVoidFunctionReturnValueUsed
      this._timer = window.clearTimeout(this._timer);
      this.isActive = false;
      this._pausedTime += Date.now() - this._startedTime;
    }
    return this;
  },

  resume() {
    const restTime = this._delay - this._pausedTime;
    this._timer = window.setTimeout(this._fn, restTime);
    this.isActive = true;
    this._startedTime = Date.now();
    return this;
  },
});

app.namespace.Util.walkTheDOM = function (node, func) {
  func(node);
  node = node.firstChild;
  while (node) {
    app.namespace.Util.walkTheDOM(node, func);
    // nextSiblingCopy makes changing the DOM tree
    if (node.nextSiblingCopy) {
      node = node.nextSiblingCopy;
    } else {
      node = node.nextSibling;
    }
  }
};

app.namespace.Util.doesVideoHaveAudio = function (videoEl) {
  return (
    videoEl.mozHasAudio ||
    Boolean(videoEl.webkitAudioDecodedByteCount) ||
    Boolean(videoEl.audioTracks && videoEl.audioTracks.length)
  );
};

app.namespace.Util.hexToRgba = function (hexString, alpha = 1) {
  const patt = /^#([\da-fA-F]{2})([\da-fA-F]{2})([\da-fA-F]{2})$/;
  const matches = patt.exec(hexString);
  const rgba =
    'rgba(' +
    parseInt(matches[1], 16) +
    ',' +
    parseInt(matches[2], 16) +
    ',' +
    parseInt(matches[3], 16) +
    ',' +
    alpha +
    ')';
  return rgba;
};

app.namespace.Util.gradientModelToCss = function (gradientModel) {
  let gradString = '';
  if (gradientModel.gradientType === 'LINEAR') {
    gradString += 'linear-gradient(';
    gradString += gradientModel.angle + 'deg ';
  } else {
    gradString += 'radial-gradient(ellipse at center ';
  }
  gradientModel.gradientColors.forEach((val) => {
    gradString += ', ' + val.color + ' ' + val.position + '%';
  });
  gradString += ')';
  return gradString;
};

app.namespace.Util.resetPatchReleaseVersion = function (version) {
  const versionArr = version.split('.');
  return `${versionArr[0]}.${versionArr[1]}.0`;
};

app.namespace.Util.tokenizeHtml = function ($el) {
  const $tokenizerWorkspace = $('<div></div>');
  const $root = $el.find('.tokenizer-root');
  const $paragraphs = $root.find('p');
  const $lists = $root.find('> ul');
  let wordIndex = 0;

  $tokenizerWorkspace.css({
    position: 'absolute',
    left: 0,
    top: 0,
    'background-color': 'white',
    'z-index': 10000,
    width: app.ASSET_EDITOR_WIDTH + 'px',
    height: app.ASSET_EDITOR_HEIGHT + 'px',
  });
  $el.css('transform', 'none');
  $tokenizerWorkspace.append($el);
  $('body').append($tokenizerWorkspace);
  $root.closest('.wt-text-overlay').addBack().show();

  const paragraphs = [];
  const boxStyle = {};
  const subStyles = [];

  $paragraphs.add($lists);
  $paragraphs.each(function (i, p) {
    const paragraphJson = { tokens: [] };
    const paragraph = $(p);
    paragraph.find('style').remove();
    if (i === 0) {
      const dir = paragraph.attr('dir');
      if (dir) {
        boxStyle.direction = dir;
      }
      let alignment = paragraph.css('text-align').toUpperCase();
      if (!['LEFT', 'RIGHT', 'CENTER', 'JUSTIFY'].includes(alignment)) {
        alignment = 'LEFT';
      }

      boxStyle.alignment = alignment;
      boxStyle.indent = parseInt(paragraph.css('padding-left'));
    }

    const paragraphText = paragraph.text().trim();

    if (_.isEmpty(paragraphText) || paragraphText === app.ZERO_WIDTH_SPACE) {
      return;
    }

    app.namespace.Util.walkTheDOM(paragraph.get(0), (node) => {
      const $node = $(node);

      let $span;
      let $lastSpan;
      let text;
      let words;

      if (node.nodeType === 3 && node.textContent !== app.ZERO_WIDTH_SPACE) {
        // Is it a Text node?
        text = $node.text();
        if (text.length > 0) {
          words = text.match(/\s+|[^\s\\!\\?,.;-]+|[\?\\!\\?,.;-]/g);
          $.each(words, function (i, word) {
            if (word.match(/\S+/)) {
              $span = $(
                '<span class="word" data-index="' + wordIndex++ + '"></span>'
              );
              $span.text(word);
            } else if (word.match(/\s+/)) {
              $span = $('<span></span>');
              $span.text(word);
            } else {
              return;
            }
            if (i === 0) {
              node.nextSiblingCopy = node.nextSibling;
              $node.replaceWith($span);
            } else {
              $span.insertAfter($lastSpan);
            }
            $lastSpan = $span;
          });
        }
      }
    });

    paragraph.find('span.word').each(function (i, word) {
      const $word = $(word);
      const wordOffset = $word.offset();
      const wordLeft = wordOffset.left;
      const wordTop = wordOffset.top;
      const token = {};
      const subStyle = {};
      token.text = $word.text();
      token.left = app.sfp(wordLeft / app.ASSET_EDITOR_WIDTH);
      token.right = app.sfp(
        (wordLeft + $word.outerWidth()) / app.ASSET_EDITOR_WIDTH
      );
      token.top = app.sfp(wordTop / app.ASSET_EDITOR_HEIGHT);
      token.bottom = app.sfp(
        (wordTop + $word.height()) / app.ASSET_EDITOR_HEIGHT
      );
      token.style = $word.css([
        'font-style',
        'font-weight',
        'font-size',
        'font-family',
        'color',
        'background-color',
      ]);
      const fontFamilyCss = token.style['font-family'];
      // noinspection JSUnresolvedFunction
      const fontFamily = app.fontController.getRegularFontFamily(fontFamilyCss);
      // noinspection JSUnresolvedFunction
      token.style['font-family'] = app.fontController.getVizName(fontFamilyCss);
      if (!_.isEmpty(token.text)) {
        subStyle.fontName = fontFamily;
        subStyle.italic = token.style['font-style'] === 'italic';
        subStyle.bold = /bold|700/i.test(token.style['font-weight']);
        subStyle.color = token.style.color;
        subStyle.weight = token.text.length;
        const identicalSubStyle = _.find(subStyles, {
          fontName: subStyle.fontName,
          italic: subStyle.italic,
          bold: subStyle.bold,
          color: subStyle.color,
        });
        if (!identicalSubStyle) {
          subStyles.push(subStyle);
        } else {
          identicalSubStyle.weight += identicalSubStyle.weight;
        }
      }
      paragraphJson.tokens.push(token);
    });

    paragraphs.push(paragraphJson);
  });
  $tokenizerWorkspace.remove();

  return { paragraphs, boxStyle, subStyles };
};

/**
 * waitUntil
 *  holds a map of promises, add method adds a promise
 *  to the map and resolve method will resolve the promise.
 *  when calling when it will return all the promises
 *  or a subset of them (pass a waitList array with names)
 */
app.namespace.Util.waitUntil = {
  _promises: {},
  _convertPromsObjToArr: function (waitList) {
    const promisesKeys = Object.keys(this._promises);

    return promisesKeys
      .filter((key) => (waitList.length ? waitList.includes(key) : true))
      .map((key) => this._promises[key]);
  },
  add: function (name, promise) {
    this._promises[name] = promise || $.Deferred();
    return this;
  },
  resolve: function (name) {
    if (this._promises[name]) {
      this._promises[name].resolve();
    } else {
      // console.log('waitUntil resolve: promise is missing! name: ' + name);
    }
    return this;
  },
  has: function (name) {
    return !!this._promises[name];
  },
  clear: function (name) {
    if (this._promises[name]) {
      delete this._promises[name];
    } else {
      // console.log('waitUntil clear: promise is missing! name: ' + name);
    }
    return this;
  },
  when: function (waitList = []) {
    const promisesArr = this._convertPromsObjToArr(waitList);
    return $.when.apply(null, promisesArr);
  },
};

/**
 * @author: Chris Veness
 * @constructor
 */
app.namespace.Util.Utf8 = class Utf8 {
  static test() {
    console.time('TIME: Utf8.test');
    const gen = new app.namespace.Util.Utf8();
    const utf8 = 'abc,Ω≈ç√∫˜µ≤≥æ…¬˚∆˙œ∑´†¥¨ˆøπ“‘';
    const unicode = gen.encode(utf8);
    const rv = utf8 === gen.decode(unicode);
    console.timeEnd('TIME: Utf8.test');
    return rv;
  }

  /**
   * Encode multi-byte Unicode string into utf-8 multiple single-byte characters
   * (BMP / basic multilingual plane only)
   * Chars in range U+0080 - U+07FF are encoded in 2 chars, U+0800 - U+FFFF in 3 chars
   * @note: Use regular expressions & String.replace callback function for better efficiency
   * than procedural approaches
   * @param unicode {String} Unicode string to be encoded as UTF-8
   * @public
   * @return {String} UTF-8 string
   */
  encode(unicode) {
    let strUtf = unicode.replace(/[\u0080-\u07ff]/g, this._into2bytes);
    strUtf = strUtf.replace(/[\u0800-\uffff]/g, this._into3bytes);
    return strUtf;
  }

  _into2bytes(c) {
    const cc = c.charCodeAt(0);
    return String.fromCharCode(0xc0 | (cc >> 6), 0x80 | (cc & 0x3f));
  }

  _into3bytes(c) {
    const cc = c.charCodeAt(0);
    return String.fromCharCode(
      0xe0 | (cc >> 12),
      0x80 | ((cc >> 6) & 0x3f),
      0x80 | (cc & 0x3f)
    );
  }

  /**
   * Decode utf-8 encoded string back into multi-byte Unicode characters
   * @note: decode 3-byte chars first as decoded 2-byte strings could appear to be 3-byte char!
   * @param utf8 {String} UTF-8 string to be decoded back to Unicode
   * @public
   * @return {String} unicode string
   */
  decode(utf8) {
    let strUni = utf8.replace(
      /[\u00e0-\u00ef][\u0080-\u00bf][\u0080-\u00bf]/g,
      this._from3bytes
    );
    strUni = strUni.replace(
      /[\u00c0-\u00df][\u0080-\u00bf]/g,
      this._from2bytes
    );
    return strUni;
  }

  _from3bytes(c) {
    const cc =
      ((c.charCodeAt(0) & 0x0f) << 12) |
      ((c.charCodeAt(1) & 0x3f) << 6) |
      (c.charCodeAt(2) & 0x3f);
    return String.fromCharCode(cc);
  }

  _from2bytes(c) {
    const cc = ((c.charCodeAt(0) & 0x1f) << 6) | (c.charCodeAt(1) & 0x3f);
    return String.fromCharCode(cc);
  }
};

/**
 * Estimate rough size of object
 * http://stackoverflow.com/a/11900218
 * @note for use during development, don't use in production
 * @param object {object}
 * @return {number} bytes
 */
app.namespace.Util.sizeof = function roughSizeOfObject(object) {
  const objectList = [];
  const stack = [object];
  let bytes = 0;

  while (stack.length) {
    const value = stack.pop();

    if (typeof value === 'boolean') {
      bytes += 4;
    } else if (typeof value === 'string') {
      bytes += value.length * 2;
    } else if (typeof value === 'number') {
      bytes += 8;
    } else if (typeof value === 'object' && objectList.indexOf(value) === -1) {
      objectList.push(value);

      for (const i in value) {
        if (Object.prototype.hasOwnProperty.call(value, i)) {
          stack.push(value[i]);
        }
      }
    }
  }

  return bytes;
};

/**
 * adaptation of https://blog.jcoglan.com/2016/07/12/mutexes-and-javascript/
 * You should confine mutexed code to only those instructions that interact
 * with a shared resource, and then release the mutex as soon as possible
 * so other code can use it.
 * @type {Mutex}
 */
app.namespace.Util.Mutex = class Mutex {
  constructor() {
    // FIFO
    this._queue = [];
    this._busy = false;
  }

  getLength() {
    return this._queue.length;
  }

  isBusy() {
    return this._busy;
  }

  /**
   * Add task to queue, use task.bind(context, arg1, arg2) to assign task arguments
   * Task function MAST return $.Deferred promise that is ALWAYS resolved/rejected
   * @param task {Function}
   * @return {jQuery.Deferred} that is resolved/rejected with the same value as task itself
   */
  synchronize(task) {
    const deferred = new $.Deferred();
    this._queue.push({ task, deferred });

    if (!this._busy) {
      this._dequeue();
    }

    return deferred;
  }

  /**
   * Pop from queue and execute
   * @private
   */
  _dequeue() {
    this._busy = true;
    const record = this._queue.shift();

    if (record) {
      this._execute(record);
    } else {
      this._busy = false;
    }
  }

  /**
   * Execute dequeued task with resolving/rejecting deferred promise,
   * created during synchronize call
   * @param task
   * @param deferred
   * @private
   */
  _execute({ task, deferred }) {
    const promise = task();

    promise.then(deferred.resolve, deferred.reject);

    if (_.isFunction(promise.finally)) {
      promise.finally(() => {
        this._dequeue();
      });
    } else if (_.isFunction(promise.always)) {
      // $.Deferred
      promise.always(() => {
        this._dequeue();
      });
    } else {
      app.doctorController.report('Mutex: job promise missing api to dequeue');
    }
  }
};

/**
 * Statistics
 * @param options
 * @constructor
 */
app.namespace.Util.Averageble = class {
  constructor(options) {
    this.reset();

    this.options = options || {
      data: [],
      // population or a sample
      population: true,
    };

    if (typeof this.options.population !== 'boolean') {
      this.options.population = true;
    }

    if (this.options.data instanceof Array) {
      for (let i = 0, I = this.options.data.length; i < I; i++) {
        this.set(this.options.data[i]);
      }
      this.options.data = null;
    }
  }

  static test() {
    // @see [9]
    const o = new app.namespace.Util.Averageble({
      data: [-5, 1, 8, 7, 2],
      population: true,
    });
    const rv = 2.6 === o.mean() && 4.673328578219168 === o.standardDeviation();
    console.assert(rv, 'Averageble.test');
    return rv;
  }

  reset() {
    this._count = 0;
    this._mean = 0;
    this._M2 = 0;
    this._variance = null;
    this._stddev = null;
    this._min = null;
    this._max = null;
    return this;
  }

  set(value) {
    ++this._count;

    if (1 === this._count) {
      this._min = value;
      this._max = value;
    } else {
      this._min = Math.min(this._min, value);
      this._max = Math.max(this._max, value);
    }

    // @see [8]
    const delta = value - this._mean;
    this._mean += delta / this._count;
    this._M2 += delta * (value - this._mean);

    if (this.options.population) {
      this._variance = this._M2 / this._count;
    } else {
      this._variance = this._M2 / (this._count - 1);
    }

    this._stddev = Math.sqrt(this._variance);

    return this;
  }

  /**
   * Number of samples
   * @return {number}
   */
  count() {
    return this._count;
  }

  /**
   * Average
   * @return {null|number}
   */
  mean() {
    return this._mean;
  }

  /**
   * Variance
   * @return {null|number}
   */
  variance() {
    return this._variance;
  }

  /**
   * Minimum
   * @return {null|number}
   */
  min() {
    return this._min;
  }

  /**
   * Maximum
   * @return {null|number}
   */
  max() {
    return this._max;
  }

  /**
   * Standard deviation ()
   * @return {null|number}
   */
  standardDeviation() {
    return this._stddev;
  }
};

// TODO: move to validate.js
app.namespace.Util.Validate = {
  email: function (email) {
    // regex was taken from: http://stackoverflow.com/questions/46155/validate-email-address-in-javascript#answer-46181
    const re =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  },
};

/**
 * Measure text offscreen (prior rendering)
 * Utilizes `measureText` api of 2d context which is created once
 * and used afterwards with each invocation.
 *
 * @note: chosen font should be already loaded
 * @example
 * app.namespace.Util.measureText.getWidth('example text')
 */
app.namespace.Util.measureText = new (function () {
  const ctx = document.createElement('canvas').getContext('2d');
  // default font descriptor
  const FONT = {
    SIZE: 16,
    NAME: ExternalScripts.MAIN_FONT,
  };

  function parseFont(input) {
    let font = '';
    if (typeof input === 'object') {
      if (!input.size) {
        input.size = FONT.SIZE;
      }
      if (!input.name) {
        input.name = FONT.NAME;
      }
      font = input.size + 'px ' + input.name;
    } else {
      font = input;
    }

    return font;
  }

  return {
    /**
     * Get string width in pixels as if it would be displayed on the screen
     * in a single line
     *
     * @param str {string}
     * string to measure
     * @param font {string|object}
     * or string in format "${font-size}px ${font-name}"
     * or object in format {size:number, name:string}
     * @return {number}
     */
    getWidth: function (str, font) {
      ctx.font = parseFont(font);
      return ctx.measureText(str).width;
    },

    /**
     * Shorthand for a probably most wide use scenario:
     * check if text is longer then `maxWidth`
     *
     * @param str {string}
     * @param font {string|object}
     * @param maxWidth {number} value to compare to
     * @return {boolean}
     */
    isLonger: function (str, font, maxWidth) {
      return this.getWidth(str, font) > maxWidth;
    },

    /**
     * Get number of lines that would be needed to display a text content
     * in a fixed-width container
     *
     * assumption - line breaks happens on spaces between words
     *
     * @param str {string}
     * @param font {string|object}
     * @param maxWidth {number}
     * container width
     * @return {number}
     */
    getLines: function (str, font, maxWidth) {
      ctx.font = parseFont(font);

      // split string by a word-breaking characters (spaces)
      const words = str.split(' ');
      let lines = 1;
      let line = '';
      let i = 0;
      while (i < words.length) {
        // add a word to a tested line
        line += (line.length ? ' ' : '') + words[i];
        // test new line if it larger then container width
        if (ctx.measureText(line).width > maxWidth) {
          // start a new line
          lines++;
          line = words[i];
        }
        i++;
      }

      return lines;
    },

    test: function () {
      const testCase = [];
      // HINT: run multiple times to get more real execution-time result

      console.time('measureText.getWidth');
      testCase.push(this.getWidth('wiiii wiiii 101 wiiii', { size: 16 }));
      console.timeEnd('measureText.getWidth');

      console.time('measureText.getLines');
      testCase.push(this.getLines('wiiii woooo 101 weeee', { size: 16 }, 40));
      console.timeEnd('measureText.getLines');

      return testCase[0] === 121.5 && testCase[1] === 4;
    },
  };
})();

/**
 * Ensure that DnD events goes only to the most recently added subscriber
 *
 * @example:
 *
 * at component mounted...
 * app.namespace.Util.FileDndDispatcher.add({
        guid: this.guid,
        handlers: {
          dragover: this.$_dragOver,
          dragenter: this.$_dragEnter,
          dragleave: this.$_dragLeave,
          drop: this.$_drop
        }
      });

 * at component beforeDestroy...
 * app.namespace.Util.FileDndDispatcher.remove(this.guid);
 */
app.namespace.Util.FileDndDispatcher = new (function () {
  const stack = [];
  const listOfEventNames = [
    'dragover',
    'dragenter',
    'dragleave',
    'dragexit',
    'dragend',
    'drop',
    'paste',
  ];

  class Client {
    constructor({ guid, handlers }) {
      this.guid = guid;
      this.handlers = handlers;
    }

    dispatch(event) {
      const handler = this.handlers[event.type];
      handler && handler(event);
    }

    destroy() {
      _.each(this.handlers, (value, key) => {
        this.handlers[key] = null;
      });
    }
  }

  function dispatch_dnd_event(e) {
    const client = stack[0];
    client && client.dispatch(e);
  }

  // register itself as single owner of dnd events
  for (const eventName of listOfEventNames) {
    document.addEventListener(eventName, dispatch_dnd_event, true);
  }

  return {
    add({ guid, handlers }) {
      if (!guid) {
        throw new Error('Expected required parameter `guid`');
      }

      let found = false;
      for (const client of stack) {
        if (client.guid === guid) {
          found = true;
          break;
        }
      }
      if (found) {
        throw new Error(
          `Attempt to register already present subscriber: ${guid}`
        );
      } else {
        // add to beginning
        stack.unshift(new Client({ guid, handlers }));
      }
    },

    remove(guid) {
      // could be at any index...
      for (const [i, client] of stack.entries()) {
        if (client.guid === guid) {
          client.destroy();
          stack.splice(i, 1);
          break;
        }
      }
    },

    get size() {
      return stack.length;
    },
  };
})();

/**
 * TODO: move this to general location.
 */
app.namespace.Util.PluginManager = class PluginManager {
  add(plugin) {
    this._list.push(plugin);
  }
  constructor() {
    this._list = [];
  }
  trigger(key, params) {
    this._list
      .filter((plugin) => typeof plugin[key] === 'function')
      .forEach((plugin) => {
        try {
          plugin[key](params);
        } catch (bug) {
          app.doctorController.report(`Plugin '${key}' crushed`, bug);
        }
      });
  }
};
